export default "__VITE_ASSET__D2T5TIP$__"